const getLogos = () => {
  const images = require.context(
    "../assets/logos",
    false,
    /\.(png|jpe?g|svg)$/
  );

  const logos = images.keys().map((path) => ({
    src: images(path),
    name: path.replace("./", "").replace(/\.(png|jpe?g|svg)$/, ""), // Extract name
  }));

  return logos;
};

export default getLogos;
